/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ReleaseDowngradeResponse interface.
 */
export function instanceOfReleaseDowngradeResponse(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
export function ReleaseDowngradeResponseFromJSON(json) {
    return ReleaseDowngradeResponseFromJSONTyped(json, false);
}
export function ReleaseDowngradeResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
    };
}
export function ReleaseDowngradeResponseToJSON(json) {
    return ReleaseDowngradeResponseToJSONTyped(json, false);
}
export function ReleaseDowngradeResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
    };
}
